import 'store/bolt/pixels.js';
import Store from 'store/store';

function roundVideoProgress(step) {
	return step === 95 ? 100 : step;
}

const pushToDataLayer = (obj) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(obj);
};

Store.on('CLICKED_FOLLOW', (name) => {
	pushToDataLayer({
		event: 'social',
		socialSite: name
	});
});

Store.on('CLICKED_SHARE', ({ label }) => {
	pushToDataLayer({
		event: 'social',
		socialSite: label
	});
});

Store.on('VIDEO_PLAYER_PROGRESS', ({ platform, video, step, time, isShowtimesMessage, isTrailerOverlay, isTrailer }) => {
	const progress = roundVideoProgress(step);
	if (progress === 0) {
		pushToDataLayer({
			event: 'video-start'
		});
		if (isTrailer) {
			pushToDataLayer({
				event: 'trailer-start'
			});
		}
	}
});

Store.on('VIDEO_ENDED', ({ isTrailer }) => {
	// might not need this?
	// dataLayer.push({ event: 'Play100' });
	pushToDataLayer({
		event: 'video-finished'
	});
	if (isTrailer) {
		pushToDataLayer({
			event: 'trailer-finished'
		});
	}
});
